import { render } from "./Interlude.vue?vue&type=template&id=db343f0a&scoped=true"
import script from "./Interlude.vue?vue&type=script&lang=js"
export * from "./Interlude.vue?vue&type=script&lang=js"

import "./Interlude.vue?vue&type=style&index=0&id=db343f0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db343f0a"]])

export default __exports__